module.exports = __webpack_public_path__ + "static/media/photo2.d47557da.jpg";